export class CaosSynchronizationConfiguration {
    installationName: string;
    isMaster: boolean;
    lastSynchronization: Date;
    syncToInstallationName: string;
    syncTime: string;

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.IsMaster != null && obj.IsMaster != undefined) this.isMaster = obj.IsMaster;
        if (obj.LastSynchronization) this.lastSynchronization = obj.LastSynchronization;
        if (obj.SyncToInstallationName) this.syncToInstallationName = obj.SyncToInstallationName;
        if (obj.SyncTime) this.syncTime = obj.SyncTime;
    }
}
